import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, navToLogin } from '@/utils/login-helper'
// import router from '@/router'
import { API_TIMEOUT } from '@/constants'
import { getPromiseState } from '@/utils/utils'

axios.defaults.timeout = 0

// axios 实例配置
const http = axios.create({
  baseURL: '/',
  timeout: API_TIMEOUT,
  validateStatus(status) {
    switch (status) {
      case 400:
        Message.error('请求出错')
        break
      case 401:
        Message.warning({ message: '授权失败，请重新登录' })
        return
      case 412:
        Message.warning({ message: '授权失败，请重新登录' })
        return
      case 403:
        Message.warning({ message: '拒绝访问' })
        break
      case 404:
        Message.warning({ message: '请求错误,未找到该资源' })
        break
      case 500:
        Message.warning({ message: '服务端错误' })
        break
    }
    return status >= 200 && status < 300
  }
})

// 标识数据的uuid
let uuid = null

// http request 拦截器
http.interceptors.request.use(
  (config) => {
    config.headers = {
      'Content-Type': 'application/json;charset=utf-8',
    }
    const token = getToken()
    if (token) {
      config.headers['x-auth-token'] = token
    }

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// 显示错误消息
let timer = null
function showErrorMessage(response) {
  const msg = response.data.msg || response.data.message || '接口请求失败，请稍后重试'
  const { config } = response
  // 登录或者不跳转到500页面
  if (config.url.includes('/login')) {
    return Message.error(msg)
  }
  timer && clearTimeout(timer)
  timer = setTimeout(() => {
    Message.error(msg)
  }, 200)
}

// http response 拦截器
http.interceptors.response.use(
  (response) => {
    Message.closeAll()
    const loginFailedCodes = [403, 401, 412]
    const errorFailedCodes = [-1, -2, -3, -4, -6, 400, 500]
    const code = response.data.status
    if (loginFailedCodes.includes(code)) {
      // 取消所有请求
      cancelRequest(null, true)
      showErrorMessage(response)
      setTimeout(navToLogin, 800)
      return Promise.reject(response.data)
    }
    if (errorFailedCodes.includes(code)) {
      showErrorMessage(response)
      return Promise.reject(response.data)
    }

    // blob类型
    if (response.request.responseType === 'blob') {
      const disposition = response.headers['content-disposition']
      let fileName = ''
      let fileNameUnicode = ''
      if (disposition && disposition.indexOf('attachment') !== -1) {
        fileName = decodeURIComponent(disposition.split(/filename\**=/)[1])
        fileNameUnicode = disposition.split('filename*=')[1]
        // 当存在 filename* 时，取filename* 并进行解码（为了解决中文乱码问题
        if (fileNameUnicode) {
          fileName = decodeURIComponent(fileNameUnicode.split("''")[1])
        }
      }
      return {
        data: response.data,
        fileName: fileName
      }
    } else {
      uuid = response.data?.result?.uuid || uuid
      return response.data
    }
  },
  (error) => {
    Message.closeAll()
    // 请求超时
    if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      return showErrorMessage({
        ...error,
        data: { msg: '接口超时, 请联系管理员！' },
      })
    }
    // 用户取消请求
    if (error.code === 'ERR_CANCELED') {
      return Promise.reject(error.message || error.code)
    }
    const status = error.response?.data?.status || error.response.status
    debugger
    switch (status) {
      case 404:
        Message.error(error.response.data.msg || error.response.data.message || '接口未找到，请确认后重试')
        return Promise.reject(error.response.data)
      case 401:
        // 取消所有请求
        cancelRequest(null, true)
        setTimeout(() => {
          cancelRequest(null, true)
          Message.closeAll()
          showErrorMessage(error.response)
        })
        setTimeout(navToLogin, 800)
        return Promise.reject(error.response.data)
      case 500:
        showErrorMessage(error.response)
        return Promise.reject(error.response.data)
      case 502:
        showErrorMessage(error.response)
        return Promise.reject(error.response.data)
      default:
        debugger
        // Message.error(error.response.data.msg);
        return Promise.reject(error.response.data)
    }
  }
)

// pathMap对象存放每次new CancelToken生成的方法
const pathMap = {}
const requestList = []
// 定义取消方法
function cancelRequest(path, allCancel = false) {
  // 请求列表里存在此path，即发起重复请求，把之前的请求取消掉
  if (path && requestList.includes(path) && typeof pathMap[path] === 'function') {
    pathMap[path]('取消请求')
  } else if (!path && allCancel) {
    // allCancel为true则请求列表里的请求全部取消
    requestList.forEach((el) => {
      pathMap[el]('批量取消请求')
    })
  }
}
// 支持取消请求
function requestCancelFn(method, path, params = {}, config = {}) {
  // 取消上一次请求
  if (requestList.length) {
    cancelRequest(path)
  }
  requestList.push(path)
  if (method === 'post') {
    return http.post(path, params, {
      cancelToken: new axios.CancelToken((c) => {
        pathMap[path] = c
      }),
      ...config,
    })
  } else if (method === 'get') {
    return http.get(path, {
      ...params,
      cancelToken: new axios.CancelToken((c) => {
        pathMap[path] = c
      }),
      ...config,
    })
  }
}

// 支持取消请求
export const getCancel = (path, params, config) => requestCancelFn('get', path, params, config)
export const postCancel = (path, params, config) => requestCancelFn('post', path, params, config)

export const get = getCancel
export const post = postCancel

// 请求map,支持单例还支持缓存
const requestMap = {}
// 单例请求
async function singleRequestFn(method, path, params = {}, config = {}) {
  // 发送一个新的接口请求
  const getRequest = () => {
    if (method === 'post') {
      return http.post(path, params, { ...config })
    } else if (method === 'get') {
      return http.get(path, { ...params, ...config })
    }
  }

  // 生成一个新的请求，并缓存下来
  const getNewRequest = () => {
    request = getRequest()
    requestMap[key] = request
    return request
  }

  // 先找是否有相同接口在请求，并且参数一致
  const key = path + JSON.stringify(params)
  const timerKey = 'timer_' + key
  let request = requestMap[key]
  if (request && config && !config.realtime) {
    // 过一定时间就手动清除这两个引用，不能续杯
    if (!requestMap[timerKey]) {
      requestMap[timerKey] = setTimeout(() => {
        delete requestMap[key]
        delete requestMap[timerKey]
      }, window.requestCacheTime || 10 * 1000)
    }
    const state = await getPromiseState(request)
    // 如果还处于pending或者fulfilled状态那么复用这个request，并设置过期时间
    if (['pending', 'fulfilled'].includes(state)) {
      return request
    }
    return getNewRequest()
  } else {
    return getNewRequest()
  }
}
// 单例请求
export const getSingle = (path, params, config) => singleRequestFn('get', path, params, config)
export const postSingle = (path, params, config) => singleRequestFn('post', path, params, config)

export default http
